/*
 * Public API Surface of ngx-lib/textbox-icon
 */
export * from './textbox-icon.module';
export * from './textbox-icon.component';
